import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../../security/service-app.service';
import { IFiltros, ITotaisPrincipal } from '../interface-apuracao-vdm-peca';
import { ApuracaoVdmPecaService, ApuracaoVdmData } from '../apuracao-vdm-peca.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-apuracao-vdm-principal-peca',
  templateUrl: './apuracao-vdm-principal-peca.component.html',
  styleUrls: ['./apuracao-vdm-principal-peca.component.scss']
})
export class ApuracaoVdmPrincipalPecaComponent implements OnInit, OnDestroy {
  cols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;
  private subscription: Subscription = new Subscription();

  totaisPrincipal: ITotaisPrincipal = {
    totalBudgetFull: 0,
    totalBudgetMtd: 0,
    totalRealizado: 0,
    totalValorDesconto: 0,
    totalValorComDesconto: 0,
    totalGapMesFull: 0,
    totalGapMesYtd: 0,
  }

  @Input() filtros: IFiltros;
  @ViewChild('dt') dt: Table;
  currency: any;
  
  constructor(
    private service: ServiceAppService, 
    private currencyPipe: CurrencyPipe,
    private apuracaoVdmService: ApuracaoVdmPecaService
  ) { 
    this.currency = this.currencyPipe;
  }

  ngOnInit(): void {
    this.inicializarColunas();
    this.subscribeToData();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private inicializarColunas() {
    this.cols = [
      { field: 'b_codDealer', header: 'Dealer' },
      { field: 'c_nomeDealer', header: 'Nome' },
      { field: 'i_budgetFullMes', header: 'Budget Full', type: this.currency, arg1: 'BRL' },
      { field: 'j_budgetMtd', header: 'Budget MTD', type: this.currency, arg1: 'BRL' },
      { field: 'k_realizadoMes', header: 'Realizado', type: this.currency, arg1: 'BRL' },
      { field: 'p_valorDescontoMes', header: 'Valor Desconto', type: this.currency, arg1: 'BRL' },
      { field: 'q_valorComDescontoMes', header: 'Valor c/ Desconto', type: this.currency, arg1: 'BRL' },
      { field: 'l_gapMesFull', header: 'Gap Mês Full', type: this.currency, arg1: 'BRL' },
      { field: 'm_gapMesYtd', header: 'Gap Mês YTD', type: this.currency, arg1: 'BRL' },
    ];
  }

  private subscribeToData() {
    this.subscription.add(
      this.apuracaoVdmService.data$.subscribe(data => {
        if (data) {
          this.dados = data.dados;
          this.totaisPrincipal = data.totaisPrincipal;
        }
      })
    );

    this.subscription.add(
      this.apuracaoVdmService.loading$.subscribe(loading => {
        this.loading = loading;
      })
    );
  }

  public retornaDados() {
    // Este método agora é chamado pelo componente pai
    // Os dados são atualizados automaticamente via subscription
  }

  /**
   * Método chamado pelo componente pai para atualizar os dados
   */
  atualizarDados(data: ApuracaoVdmData) {
    this.dados = data.dados;
    this.totaisPrincipal = data.totaisPrincipal;
  }
}